import React, { useState, useContext } from "react";
import { AiOutlineWarning } from "react-icons/ai";
//import { useNavigate, useLocation } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import CustomAlert from "../../shared/CustemAlert";
import HelpModal from "../../shared/HelpModal";
import HelpContext from "../../shared/context/HelpProvider";
import { MdLiveHelp } from "react-icons/md";
import MyJustDate from "../../shared/MyJustDate";
const baseURL = process.env.REACT_APP_API_JOBS;

export default function Add({ increment, moamad, hagsha_aharon }) {
  const { setSaeef, setShowHelp } = useContext(HelpContext);
  const axiosPrivate = useAxiosPrivate("application/json");
  //const navigate = useNavigate();
  //const location = useLocation();
  const [newExpr, setNewExpr] = useState({
    address: "",
    start_date: "",
    end_date: "",
    job: "",
    last_salary: "",
    end_reason: "נוכחית",
    moamad: moamad.id,
  });
  const [showCustomAlert, setShowCustomAlert] = useState(false);
  const readOnly =
    moamad.signature_date ||
    MyJustDate(new Date(Date.parse(hagsha_aharon))) < MyJustDate(Date.now());

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setNewExpr((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axiosPrivate.post(
        baseURL + "workexperience/",
        newExpr
      );
      increment();
      setShowCustomAlert(true);
    } catch (err) {
      // Handle errors
    }
  };

  return (
    <div>
      <HelpModal />
      <center>
        <div className="container">
          <div className="card text-dark bg-light p-3 border">
            {moamad.signature_date ? (
              <h4 style={{ color: "green" }}>
                המעמדות שלך למכרז נחתמה ושוגרה, לא תוכל להוסיף עדכונים.
              </h4>
            ) : (
              <h4 style={{ color: "red" }}>
                <AiOutlineWarning />
                שים לב המועמדות שלך למכרז, עדיין לא נחתמה ולא שוגרה.
                <AiOutlineWarning />
              </h4>
            )}

            <h5
              onClick={() => {
                setSaeef("4-5");
                setShowHelp(true);
              }}
            >
              ניסיון תעסוקתי של המועמד: {moamad.f_name}{" "}
              {moamad.father_name ? moamad.father_name + " " : ""}{" "}
              {moamad.l_name}{" "}
              <span className="help">
                <MdLiveHelp />
              </span>
            </h5>
          </div>
          {!readOnly && (
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="address" className="required-label">
                    שם וכתובת מקום העבודה
                  </label>
                  <input
                    type="text"
                    name="address"
                    className="form-control"
                    id="address"
                    value={newExpr.address}
                    onChange={handleChange}
                    required
                  />
                </div>
                <Row>
                  <Col xs={12} sm={6}>
                    <div className="form-group">
                      <label htmlFor="start_date" className="required-label">
                        תחילת עבודה
                      </label>
                      <input
                        type="date"
                        name="start_date"
                        className="form-control"
                        id="start_date"
                        value={newExpr.start_date}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </Col>
                  <Col xs={12} sm={6}>
                    <div className="form-group">
                      <label htmlFor="end_date" className="required-label">
                        סיום עבודה
                      </label>
                      <input
                        type="date"
                        name="end_date"
                        className="form-control"
                        id="end_date"
                        value={newExpr.end_date}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={6}>
                    <div className="form-group">
                      <label htmlFor="job" className="required-label">
                        תפקיד
                      </label>
                      <input
                        type="text"
                        name="job"
                        className="form-control"
                        id="job"
                        value={newExpr.job}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </Col>
                  <Col xs={12} sm={6}>
                    <div className="form-group">
                      <label htmlFor="last_salary" className="required-label">
                        השכר שהתקבל לאחרונה/דרגה
                      </label>
                      <input
                        type="text"
                        name="last_salary"
                        className="form-control"
                        id="last_salary"
                        value={newExpr.last_salary}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </Col>
                </Row>
                <div className="form-group">
                  <label htmlFor="end_reason" className="required-label">
                    סיבת הפסקת העבודה
                  </label>
                  <input
                    type="text"
                    name="end_reason"
                    className="form-control"
                    id="end_reason"
                    value={newExpr.end_reason}
                    onChange={handleChange}
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary">
                  הוסף
                </button>
              </form>
              {showCustomAlert && (
                <div className="alert-max-width">
                  <CustomAlert
                    setShow={setShowCustomAlert}
                    alertHeader="הוספת ניסיון למועמד"
                    alertBody="הניסיון נוסף בהצלחה"
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </center>
    </div>
  );
}
